import { findDataInFields } from "../../../utils/helperFuctions";

const MultiFieldsDisplay = ({ label, type, name, fields, displayFields }) => {
  const displayFieldsParser = (fields, displayFields) => {
    return displayFields
      .map((field) => {
        const value = findDataInFields(fields, field);
        return value != null ? value : null; // Return value or null
      })
      .filter((v) => v != null) // Remove null/undefined
      .join(" "); // Join into a single string with spaces
  };

  const value = displayFieldsParser(fields, displayFields);
  return (
    <div>
      <label className="block text-sm font-medium leading-6 text-gray-900 text-left">
        {label}
      </label>
      <div className="block text-sm font-medium leading-6 text-[#6b7280] text-left">
        {value}
      </div>
    </div>
  );
};

export default MultiFieldsDisplay;
